export const appTitle = "Clayton Jang";

export const apiPath = "https://claytonjang.com/portfolio-wp/wp-json/wp/v2"
export const apiPath_projects = `${apiPath}/cj-project`
export const apiPath_pages = `${apiPath}/pages`

// Main Navbar Links
export const navMainLinks = [
  {
    name: "Home",
    path: "/#home"
  },
  {
    name: "Work",
    path: "/#work"
  },
  {
    name: "About",
    path: "/#about"
  },
  {
    name: "Contact",
    path: "/#contact"
  },
]